import * as React from "react";

import { useProductListController_forFiltering } from "../providers";

export const ZeroFilterResults: React.FunctionComponent = () => {
  const { handleRemoveAllSelectedOptions } =
    useProductListController_forFiltering();

  return (
    <div className="zero-filter-results">
      <h2>Your filters do not match any results.</h2>
      <p>Try removing some filters or reset all your filters below.</p>
      <button
        className="button--secondary"
        onClick={handleRemoveAllSelectedOptions}
      >
        Reset Filters
      </button>
    </div>
  );
};
